export default __webpack_public_path__ + "assets/cape-verde-flag.png";